module.exports = function (fork) {
  fork.use(require("./babel-core"));
  fork.use(require("./flow"));
};



//////////////////
// WEBPACK FOOTER
// ./~/ast-types/def/babel.js
// module id = 26
// module chunks = 0